import React, { useRef, useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Link from '@mui/material/Link';
import { FormattedMessage } from '../i18n';
import { challengeMessages } from './messages';
import {
  settleChallenge,
  useCloudflareChallengeStore,
} from '../api/sdmx/cloudflare-challenge';

const START = 'start';
const VERIFYING = 'verifying';
const BLOCKED = 'blocked';

const CloudflareChallenge = () => {
  const space = useCloudflareChallengeStore((state) => state.space);
  const popup = useRef(null);
  const [step, setStep] = useState(START);
  const verifyUrl = space?.cloudflareChallenge?.verifyUrl;

  const verify = () => {
    // must run in the click handler, browsers block popups opened later
    popup.current = window.open(
      verifyUrl,
      'cloudflare-challenge',
      'width=520,height=640',
    );
    setStep(popup.current ? VERIFYING : BLOCKED);
  };

  const close = (isVerified) => {
    popup.current?.close();
    popup.current = null;
    setStep(START);
    settleChallenge(isVerified);
  };

  return (
    <Dialog open={!!space} aria-labelledby="cloudflare-challenge-title">
      <DialogTitle id="cloudflare-challenge-title">
        <FormattedMessage {...challengeMessages.title} />
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          <FormattedMessage {...challengeMessages.body} />
        </DialogContentText>
        {step === VERIFYING && (
          <DialogContentText>
            <FormattedMessage {...challengeMessages.verifying} />
          </DialogContentText>
        )}
        {step === BLOCKED && (
          <>
            <DialogContentText>
              <FormattedMessage {...challengeMessages.blocked} />
            </DialogContentText>
            <Link href={verifyUrl} target="_blank" rel="noopener noreferrer">
              <FormattedMessage {...challengeMessages.open} />
            </Link>
          </>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={() => close(false)}>
          <FormattedMessage {...challengeMessages.cancel} />
        </Button>
        {step === START ? (
          <Button variant="contained" onClick={verify}>
            <FormattedMessage {...challengeMessages.verify} />
          </Button>
        ) : (
          <Button variant="contained" onClick={() => close(true)}>
            <FormattedMessage {...challengeMessages.continue} />
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default CloudflareChallenge;
